import React, { useEffect, useState } from "react";
import ReactDOMServer from "react-dom/server";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

import Content from "../common/template/content";
import ContentCard from "../common/template/contentCard";
import ContentCardHeader from "../common/template/contentCardHeader";
import ContentCardBody from "../common/template/contentCardBody";
import Row from "../common/layout/row";
import Grid from "../common/layout/grid";
import Table from "../common/table/table";
import THead from "../common/table/tHead";
import Tr from "../common/table/tr";
import NewTr from "../common/table/newTr";
import Th from "../common/table/th";
import TBody from "../common/table/tBody";
import Td from "../common/table/td";
import ButtonTable from "../common/table/buttonTable";
import FormDataPagamento from "./faturaFormDataPagamento";
import Select from "../common/form/select";

import { DisplayPDF } from "../displayPDF/displayPDF";
import LabelAndCheckbox from "../common/form/labelAndCheckbox";
import Button from "../common/button/button";
import DateFormat from "../common/dateFormat/DateFormat";
import TabelaFaturaClientePDF from "../htmlToPdf/TabelaFaturaClientePDF";
import { adicionarPontosMilhar } from "../utils/adicionarPontosMilhar";
import AlertIcon from "../common/alertIcon/alertIcon";

import {
    setModoTela,
    initForm,
    setFiltro,
    getListaFaturasCliente,
    buscarPdf,
    setDataPagamento,
    setAguardando,
    incluirDownloadRealizado,
    excluirDownloadRealizado,
    baixarMultiplasFaturasPdf,
    imprimirMultiplasFaturas,
    getTotalFaturaEmpenho,
    buscarPdfFaturaAdicional,
    extrairDadosPDF,
    gerarRelatorio,
    gerarXlsx,
    getFaturasVencidasUltimos4Meses,
    getListaGraficoGeracaoSaldo,
    setListaFaturasRedirecionamento,
    getListaClientesUcsFiltradosSelect,
} from "./faturaActions";

import { setArquivoPDF } from "../displayPDF/displayPDFActions";

import { getListaGrupoFaturamento } from "../cliente/clienteActions";
import { getLista as getListaEmpenho } from "../empenho/empenhoActions";
import { Loading } from "../common/loading/loading";
import { setError, setSuccess } from "../common/toast/toast";
import FormatUtils from "../common/formatUtils/FormatUtils";
import { ModalGestorConcessonaria } from "../analise/components/ModalGestorConcessionaria";
import TableInCell from "../common/table/tableInCell";
import { BotaoGerarRelatorio } from "../common/button/BotaoGerarRelatorio";
import { InfoIcon } from "../common/infoIcon/InfoIcon";
import { ModalBalancoEnergetico } from "../geracaoLeitura/components/ModalBalancoEnergetico";
import { SolCasaFatura } from "./components/SolCasaFatura";
import { TabelaSaldosFatura } from "./components/TabelaSaldosFatura";
import { ModalGraficoSaldos } from "./components/ModalGraficoSaldos";
import { ModalSelecaoPdfFatura } from "./components/ModalSelecaoPdfFatura";
import { ModalFaturasVencidas } from "./components/ModalFaturasVencidas";
import { FiltrosFaturasClienteEnergia } from "./components/FiltrosFaturasClienteEnergia";

const INITIAL_STATE = {
    statusCorBranca: true, //não importado
    statusCorAzul: true, //importadas e NÃO vencidas
    statusCorAmarela: true, //falta 2 dias para o vencimento
    statusCorVermelha: true, //vencidas e não pagas
    statusCorVerde: true, //qualquer uma paga
    situacaoDownload: 1, //Mostra todas
    exibirModalSelecaoFatura: false,
    exibirModalFaturasVencidas: false,
    exibirGraficoSaldoGeracao: false,
    itemPdfSelecionado: null,
    ultimoFiltroUtilizado: null, //usa isso para evitar buscar quando o filtro não mudou
    exibirModalGestorConcessionaria: false,
    exibirModalBalancoEnergetico: false,
    itemSelecionado: null,
};

const INITIAL_TOTAIS = {
    quantidadeUnidadesFiltradas: 0,
    qtdCorBranca: 0,
    qtdCorAmarela: 0,
    qtdCorAzul: 0,
    qtdCorVerde: 0,
    qtdCorVermelha: 0,
    totalValorFatura: 0,
};

const CORES = {
    BRANCA: { backgroundColorTr: "rgb(255, 255, 255)", backgroundColorTd: "rgb(245, 245, 245)" },
    //se estiver paga retorna verde
    VERDE: { backgroundColorTr: "rgb(221, 255, 221)", backgroundColorTd: "rgb(68, 255, 170)" },
    AZUL: {
        backgroundColorTr: "rgb(243 255 255)",
        backgroundColorTd: "rgb(197 255 255)",
    },
    AMARELA: {
        backgroundColorTr: "rgb(255 255 212)",
        backgroundColorTd: "rgb(255 239 113)",
    },
    VERMELHA: {
        backgroundColorTr: "rgb(251 202 202)",
        backgroundColorTd: "rgb(255 101 105)",
    },
};

function FaturaEnergiaCliente(props) {
    const [faturasFiltradas, setFaturasFiltradas] = useState([]);
    const [state, setState] = useState(INITIAL_STATE);
    const [totais, setTotais] = useState(INITIAL_TOTAIS);

    const clienteSelecionado = props.listaCliente.find((cli) => cli.id == props.filtro.id_cliente);
    const exibirFiltroEmpenho = props.usuarioLogado.cliente_prefeitura || (clienteSelecionado && clienteSelecionado.cliente_prefeitura);

    //execução inicial, buca as listas de cliente, uc, etc..
    useEffect(() => {
        if (!props.usuarioLogado) return;
        props.getListaClientesUcsFiltradosSelect();
        props.getListaGrupoFaturamento();

        if (props.usuarioLogado.acesso_cliente) {
            props.setFiltro({
                ...props.filtro,
                id_cliente: props.usuarioLogado.id_cliente,
            });
        }
    }, []);

    //só busca se for necessário exibir o empenho
    useEffect(() => {
        if (!props.usuarioLogado || !exibirFiltroEmpenho) return;
        props.getListaEmpenho(props.filtro.id_cliente, props.filtro.ano);
    }, [props.usuarioLogado, props.filtro.id_cliente, props.filtro.ano]);

    //só busca se nao for acesso cliente ou se o cliente for o mesmo do usuário logado
    useEffect(() => {
        // cliente diferente do logado
        if (!props.usuarioLogado || (props.usuarioLogado.acesso_cliente && props.filtro.id_cliente != props.usuarioLogado.id_cliente)) return;
        props.getListaFaturasCliente();
        props.getFaturasVencidasUltimos4Meses();
    }, [props.usuarioLogado, props.filtro]);

    useEffect(() => {
        if (!props.usuarioLogado || (props.usuarioLogado.acesso_cliente && props.filtro.id_cliente != props.usuarioLogado.id_cliente)) {
            setFaturasFiltradas([]);
            return;
        }
        const listaAtualizada = [];
        const totaisAtualizados = { ...INITIAL_TOTAIS };
        for (const item of props.lista) {
            if (!itemCorrespondeAoFiltro(item)) {
                // console.log("uc" + item.id_unidade_consumidora + " IGNORADA");
                continue;
            }
            listaAtualizada.push(item);
            contabilizarTotais({ item, totais: totaisAtualizados });
            // console.log(item.id_unidade_consumidora + " INCLUIDO");
        }

        setFaturasFiltradas(listaAtualizada);
        setTotais(totaisAtualizados);
    }, [
        props.lista,
        props.usuarioLogado,
        props.filtro,
        state.situacaoDownload,
        state.statusCorAzul,
        state.statusCorAmarela,
        state.statusCorVermelha,
        state.statusCorVerde,
        state.statusCorBranca,
    ]);

    const usuarioLogadoAcessoCliente = props.usuarioLogado && props.usuarioLogado.acesso_cliente;

    if (props.pdf) {
        return (
            <DisplayPDF
                setDownloadRealizado={() => props.incluirDownloadRealizado([props.id_pdf])}
                closePdf={props.setArquivoPDF}
                pdfBase64={props.pdf}
                nomePdf={props.nomePdf}
                zoomParametro={1.5}
            />
        );
    }
    const isMobile = window.innerWidth <= 768;
    return (
        <div>
            {props.aguardando ? <Loading /> : null}
            <ModalGraficoSaldos
                visible={state.exibirGraficoSaldoGeracao && !props.pdf && !props.aguardando}
                handleClose={() => setState({ ...state, exibirGraficoSaldoGeracao: false, itemSelecionado: null })}
                listaGraficoGeracaoSaldo={props.listaGraficoGeracaoSaldo}
                gerarRelatorio={props.gerarRelatorio}
                state={state}
            />
            <ModalSelecaoPdfFatura
                visible={state.exibirModalSelecaoFatura && !props.pdf}
                handleClose={() => setState({ ...state, exibirModalSelecaoFatura: false, itemPdfSelecionado: null })}
                buscarPdf={props.buscarPdf}
                state={state}
                usuarioLogado={props.usuarioLogado}
                setArquivoPDF={props.setArquivoPDF}
                buscarPdfFaturaAdicional={props.buscarPdfFaturaAdicional}
            />

            <ModalFaturasVencidas
                visible={state.exibirModalFaturasVencidas}
                handleClose={() => setState({ ...state, exibirModalFaturasVencidas: false })}
                handleVerificarFaturas={handleVerificarFaturas}
                listaFaturasVencidas={props.listaFaturasVencidas}
            />

            <ModalBalancoEnergetico
                itemSelecionado={state.itemSelecionado}
                visible={state.exibirModalBalancoEnergetico && state.itemSelecionado}
                handleClose={() => setState({ ...state, exibirModalBalancoEnergetico: false, itemSelecionado: null })}
            />
            <Content>
                {props.modoTela === "lista" ? lista() : null}
                {props.modoTela === "alterarDataPagamento" ? <FormDataPagamento onSubmit={props.setDataPagamento} /> : null}
                {props.modoTela === "excluirDataPagamento" ? <FormDataPagamento excluir onSubmit={props.setDataPagamento} /> : null}
                {props.modoTela === "visualizarDataPagamento" ? <FormDataPagamento visualizar /> : null}
            </Content>
        </div>
    );

    function itemCorrespondeAoFiltro(item) {
        const azuis = item.cor === "AZUL" && state.statusCorAzul;
        const amarelos = item.cor === "AMARELA" && state.statusCorAmarela;
        const vermelhos = item.cor === "VERMELHA" && state.statusCorVermelha;
        const verdes = item.cor === "VERDE" && state.statusCorVerde;
        const brancos = item.cor === "BRANCA" && state.statusCorBranca;
        const filtroPorCores = brancos || verdes || azuis || amarelos || vermelhos;
        const mesmoGrupoFaturamento = !props.filtro.id_grupo_faturamento || item.id_grupo_faturamento == props.filtro.id_grupo_faturamento;

        //1 traz todas, 2 apenas baixadas, 3 apenas download pendente
        const filtroSituacaoDownload =
            state.situacaoDownload == 2 ? validarDownloadRealizado(item) : state.situacaoDownload == 3 ? !validarDownloadRealizado(item) : state.situacaoDownload == 1;

        const filtroConcessionaria = !props.filtro.id_concessionaria || props.filtro.id_concessionaria == item.id_concessionaria;

        return mesmoGrupoFaturamento && filtroPorCores && filtroSituacaoDownload && filtroConcessionaria;
    }

    function contabilizarTotais({ item, totais }) {
        totais.quantidadeUnidadesFiltradas++;
        totais.totalValorFatura += parseFloat(item.valor_fatura > 0 ? item.valor_fatura : 0);

        if (item.cor === "BRANCA") totais.qtdCorBranca++;
        if (item.cor === "AMARELA") totais.qtdCorAmarela++;
        if (item.cor === "AZUL") totais.qtdCorAzul++;
        if (item.cor === "VERDE") totais.qtdCorVerde++;
        if (item.cor === "VERMELHA") totais.qtdCorVermelha++;
    }

    function listarUCsFiltradas() {
        const ucsFiltradas = props.listaUnidadeConsumidora.filter(
            (item) =>
                ((!props.filtro.id_cliente && props.usuarioLogado && props.usuarioLogado.administrador) || item.id_cliente == props.filtro.id_cliente) &&
                (!props.filtro.id_grupo_faturamento || item.id_grupo_faturamento == props.filtro.id_grupo_faturamento) &&
                ((props.filtro.irrigante && item.irrigante) || (props.filtro.naoIrrigante && !item.irrigante))
        );
        return ucsFiltradas;
    }

    function validarDownloadRealizado(item) {
        return !!(item.id_usuario_download_realizado || []).find((id_usuario) => id_usuario == props.usuarioLogado.id);
    }

    function copiarTextoClipboard(texto) {
        navigator.clipboard
            .writeText(texto)
            .then(() => {
                setSuccess(`Conteúdo copiado: ${texto}`);
            })
            .catch((err) => {
                setError("Não foi possível copiar o conteúdo");
            });
    }

    function montarBotoes(item) {
        const botoes = [];
        if (item.cor && item.cor !== "BRANCA") {
            if (item.fatura_isenta) {
                botoes.push({
                    children: (
                        <span
                            style={{
                                width: "100%",
                                borderRadius: "0.3rem",
                                backgroundColor: "#00adff",
                                color: "#FFF",
                                padding: 5,
                            }}
                        >
                            Fatura Isenta
                        </span>
                    ),
                });
            } else {
                if (item.data_pagamento) {
                    botoes.push({
                        title: "Remover data de pagamento",
                        type: "danger",
                        disabled: !props.usuarioLogado.acesso_fatura_data_pagamento_editar,
                        event: () => {
                            const registro = {
                                dados_fatura: {
                                    competencia: item.competencia_formatada,
                                    nome_cliente: item.nome_cliente,
                                    nome_unidade_consumidora: item.nome_unidade_consumidora,
                                    data_vencimento: item.data_vencimento ? String(item.data_vencimento).substring(0, 10) : null,
                                },
                                id: item.id,
                                id_cliente: item.id_cliente,
                                id_unidade_consumidora: item.id_unidade_consumidora,
                                data_pagamento: item.data_pagamento ? String(item.data_pagamento).substring(0, 10) : null,
                                comprovantes_pagamento: JSON.parse(item.comprovantes_pagamento),
                                id_usuario_data_pagamento: props.usuarioLogado.id,
                            };
                            //define a data atual
                            props.setModoTela("excluirDataPagamento", registro);
                            props.initForm(registro);
                            //props.setDataPagamento(item);
                        },
                        children: (
                            <div
                                style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    flexWrap: "noWrap",
                                }}
                            >
                                <i className="fas fa-comment-dollar"></i>
                                <i className="fas fa-times" style={{ fontSize: "0.6rem" }}></i>
                            </div>
                        ),
                    });
                } else {
                    botoes.push({
                        title: "Adicionar data de pagamento",
                        type: "success",
                        icon: "fas fa-comment-dollar",
                        disabled: !props.usuarioLogado.acesso_fatura_data_pagamento_editar,
                        event: () => {
                            const registro = {
                                dados_fatura: {
                                    competencia: String(item.competencia).substring(4) + "/" + String(item.competencia).substring(0, 4),
                                    nome_cliente: item.nome_cliente,
                                    nome_unidade_consumidora: item.nome_unidade_consumidora,
                                    data_vencimento: item.data_vencimento ? String(item.data_vencimento).substring(0, 10) : null,
                                },
                                id: item.id,
                                id_cliente: item.id_cliente,
                                id_unidade_consumidora: item.id_unidade_consumidora,
                                data_pagamento: new Date().toISOString().substring(0, 10),
                                comprovantes_pagamento: JSON.parse(item.comprovantes_pagamento),
                                id_usuario_data_pagamento: props.usuarioLogado.id,
                            };
                            //define a data atual
                            props.setModoTela("alterarDataPagamento", registro);
                            props.initForm(registro);
                            //props.setDataPagamento(item);
                        },
                    });
                }
                if (item.importado || item.arquivo_pdf) {
                    botoes.push({
                        style: {
                            width: 38,
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                        },
                        title: "Visualizar",
                        type: "primary",
                        icon: "fas fa-eye",
                        event: () => {
                            const registro = {
                                dados_fatura: {
                                    competencia: String(item.competencia).substring(4) + "/" + String(item.competencia).substring(0, 4),
                                    nome_cliente: item.nome_cliente,
                                    nome_unidade_consumidora: item.nome_unidade_consumidora,
                                    data_vencimento: item.data_vencimento ? String(item.data_vencimento).substring(0, 10) : null,
                                },
                                id: item.id,
                                id_cliente: item.id_cliente,
                                id_unidade_consumidora: item.id_unidade_consumidora,
                                data_pagamento: item.data_pagamento ? String(item.data_pagamento).substring(0, 10) : null,
                                comprovantes_pagamento: JSON.parse(item.comprovantes_pagamento),
                                id_usuario_data_pagamento: props.usuarioLogado.id,
                            };
                            //define a data atual
                            props.setModoTela("visualizarDataPagamento", registro);
                            props.initForm(registro);
                        },
                    });
                }
            }
        }

        return botoes;
    }

    function gerarDadosRelatorioXlsx() {
        return [...faturasFiltradas].map((item) => {
            //FORMATA COMPETENCIA
            const registroFatura = item.id;
            const foiValidada = item.visualizacao_disponivel_cliente;

            const retorno = {};

            retorno["Status Imp. Fatura"] = registroFatura && foiValidada ? "Validado" : "Não Importado";
            retorno["Status Imp. Prod. Solar"] = registroFatura
                ? parseFloat(item.quantidade_geracao || 0) <= 0
                    ? "Importação Solar Pendente"
                    : "Geração Solar Importada"
                : "Não Importado";
            retorno["Saldo Prod. Solar"] = registroFatura
                ? item.unidade_geradora || item.unidade_remota
                    ? [1, 4].includes(item.id_grupo_faturamento)
                        ? `P: ${Math.round(item.saldo_geracao_ponta || 0) + " kWh"} | FP: ${
                              Math.round(item.saldo_geracao_fora_ponta || 0) + " kWh"
                          } | Total: ${Math.round(item.saldo_geracao || 0) + " kWh"}`
                        : "" + Math.round(item.saldo_geracao || 0)
                    : ""
                : "";
            retorno["Competência"] = item.competencia_formatada;
            if (!usuarioLogadoAcessoCliente) {
                retorno["Cliente"] = item.nome_cliente;
            }
            retorno["Data de Emissão da Nota Fiscal"] = item.data_emissao_nota_fiscal ? `${DateFormat.formatarDataSqlParaTela(item.data_emissao_nota_fiscal)}` : "";
            retorno["Nº da Nota Fiscal"] = item.numero_nota_fiscal ? `${item.numero_nota_fiscal}${item.serie_nota_fiscal ? " - " + item.serie_nota_fiscal : ""}` : "";
            retorno["Unidade Consumidora"] = item.nome_unidade_consumidora + " (" + item.nome_concessionaria + ")";
            retorno["Tipo Medição"] = item.sigla_tipo_medicao || "";
            retorno["Tipo de Transformador"] = item.nome_tipo_transformador || "";
            retorno["Grupo de Faturamento"] = item.sigla_grupo_faturamento || "";
            retorno["Data de Vencimento"] = item.data_vencimento ? DateFormat.formatarDataSqlParaTela(item.data_vencimento) : "";
            const dataPagamento =
                item.nome_usuario_data_pagamento && !item.data_pagamento ? "Removida" : item.data_pagamento ? DateFormat.formatarDataSqlParaTela(item.data_pagamento) : "";
            retorno["Data de Pagamento"] = item.fatura_isenta ? "Fatura Isenta" : dataPagamento;
            retorno["Usuário de Alteração da Data de Pagamento"] = item.fatura_isenta
                ? "Definida pelo sistema"
                : item.data_pagamento
                  ? item.nome_usuario_data_pagamento || "Definida pelo sistema"
                  : item.nome_usuario_data_pagamento || "";
            retorno["Data/Hora de Alteração da Data de Pagamento"] = item.fatura_isenta
                ? "Definida pelo sistema"
                : item.datahora_alteracao_data_pagamento
                  ? DateFormat.formatarDataHoraSqlParaTela(item.datahora_alteracao_data_pagamento)
                  : "";
            retorno["Total Fatura"] = "R$ " + adicionarPontosMilhar(item.valor_fatura || 0);
            retorno["PDF"] =
                (item.arquivo_pdf ||
                    item.arquivo_pdf_custo_energia_acl_cp ||
                    item.arquivo_pdf_custo_energia_acl_lp ||
                    item.arquivo_pdf_custo_gestao_acl ||
                    item.arquivo_pdf_contribuicao_associativa_ccee) &&
                item.visualizacao_disponivel_cliente
                    ? "Disponível"
                    : "Indisponível";
            retorno["Cód. Barras"] = item.visualizacao_disponivel_cliente ? "Disponível" : "Indisponível";
            retorno["Download Realizado"] = item.arquivo_pdf && validarDownloadRealizado(item) ? "Sim" : "Não";

            return retorno;
        });
    }

    function lista() {
        //se for admin logado só mostra filtro e card de empenho quando seleciona um cliente do tipo prefeitura
        //se for cliente logado, só mostra filtro e card de empenho se o cliente logado for do tipo prefeitura

        let statusAtivos = [];
        if (state.statusCorBranca) statusAtivos.push("Não importada");
        if (state.statusCorAzul) statusAtivos.push("Importada e não vencida");
        if (state.statusCorAmarela) statusAtivos.push("Um ou dois dias para o vencimento");
        if (state.statusCorVermelha) statusAtivos.push("Vencendo hoje ou vencida");
        if (state.statusCorVerde) statusAtivos.push("Paga");
        if (state.statusImportacaoSolarVerde) statusAtivos.push("Solar importado");
        if (state.statusImportacaoSolarVermelha) statusAtivos.push("Solar não importado");

        if (
            state.statusCorBranca &&
            state.statusCorVerde &&
            state.statusCorAzul &&
            state.statusCorAmarela &&
            state.statusCorVermelha &&
            !state.statusImportacaoSolarVerde &&
            !state.statusImportacaoSolarVermelha
        ) {
            statusAtivos = "Mostrar todas";
        }

        // const tabelaFaturas = faturasFiltradas.map((item) => {

        //     //ao chegar na última iteração constrói o rodapé

        //     return {
        //         componente: linha,
        //         id_usuario_implantacao: item.id_usuario_implantacao,
        //         nome_cliente: item.nome_cliente,
        //         nome_unidade_consumidora: item.nome_unidade_consumidora,
        //         nome_concessionaria: item.nome_concessionaria,
        //         data_emissao_nota_fiscal: item.data_emissao_nota_fiscal,
        //         numero_nota_fiscal: item.numero_nota_fiscal,
        //         serie_nota_fiscal: item.serie_nota_fiscal,
        //     };
        // });

        //DADOS PARA IMPRESSÃO DO RELATÓRIO ---------------
        const cabecalho = (
            <NewTr backgroundColorTr={"#FFFFFF"} backgroundColorTd={"#F5F5F5"}>
                <Th sticky style={{ fontSize: "0.7rem" }} alignCenter title="Status da Importação das Faturas de Energia Elétrica">
                    Status Imp. Fatura
                </Th>
                <Th sticky style={{ fontSize: "0.7rem" }} minWidth={65} alignCenter title="Status da Importação de Produção de Energia Elétrica Solar">
                    Status Imp. Prod. Solar
                </Th>
                <Th sticky style={{ fontSize: "0.7rem" }} minWidth={75} alignCenter backgroundColor={"#f9f9f9"} title="Saldo de Produção Solar da Fatura de Energia Elétrica">
                    Saldo Prod. Solar
                </Th>
                <Th sticky style={{ fontSize: "0.7rem" }} minWidth={75} alignCenter>
                    Competência
                </Th>
                {!usuarioLogadoAcessoCliente && (
                    <Th sticky style={{ fontSize: "0.7rem" }} alignCenter>
                        Cliente
                    </Th>
                )}
                <Th sticky style={{ fontSize: "0.7rem" }} alignCenter>
                    Nº da Nota Fiscal
                </Th>
                <Th sticky style={{ fontSize: "0.7rem" }} alignCenter>
                    UC
                </Th>
                <Th sticky style={{ fontSize: "0.7rem" }} minWidth={120} alignCenter>
                    Característica de Conexão com Distribuidora de Energia
                </Th>
                <Th sticky style={{ fontSize: "0.7rem" }} minWidth={50} alignCenter>
                    Data de Vencimento
                </Th>
                <Th sticky style={{ fontSize: "0.7rem" }} minWidth={50} alignCenter>
                    Data de Pagamento
                </Th>
                <Th sticky style={{ fontSize: "0.7rem" }} minWidth={50} alignCenter>
                    Usuário de Alteração Data de Pagamento
                </Th>
                <Th sticky style={{ fontSize: "0.7rem" }} minWidth={50} alignCenter>
                    Total Fatura
                </Th>
                <Th sticky style={{ fontSize: "0.7rem" }} alignCenter>
                    Faturas
                </Th>
                <Th sticky style={{ fontSize: "0.7rem" }} alignCenter>
                    Cód. Barras
                </Th>
                <Th sticky style={{ fontSize: "0.7rem" }}>
                    Download Realizado
                </Th>
            </NewTr>
        );

        const rodape = (
            <Tr>
                <Td fontWeight="bold">Total</Td>
                <Td colSpan={usuarioLogadoAcessoCliente ? 7 : 8} fontWeight="bold">
                    Qtd. Unidades Ativas Filtradas: {totais.quantidadeUnidadesFiltradas} un.
                </Td>
                <Td alignCenter fontWeight="bold">
                    {"R$ " + adicionarPontosMilhar(totais.totalValorFatura || 0)}
                </Td>
                <Td colSpan={4}></Td>
            </Tr>
        );

        const listaUcsFiltradas = listarUCsFiltradas();
        return (
            <ContentCard>
                <ModalGestorConcessonaria
                    visible={state.exibirModalGestorConcessionaria && state.itemSelecionado && state.itemSelecionado.gestor_concessionaria_energia}
                    itemSelecionado={state.itemSelecionado}
                    handleClose={() => setState({ ...state, exibirModalGestorConcessionaria: false, itemSelecionado: null })}
                />
                <ContentCardBody>
                    <FiltrosFaturasClienteEnergia
                        listaUnidadeConsumidora={listaUcsFiltradas}
                        setState={(novoFiltro) => setState(novoFiltro)}
                        filtroState={{ ...state }}
                        statusAtivos={statusAtivos}
                        quantidadesFiltro={{ ...totais }}
                        isMobile={isMobile}
                        usuarioLogadoAcessoCliente={usuarioLogadoAcessoCliente}
                        exibirFiltroEmpenho={exibirFiltroEmpenho}
                        buttons={[
                            <BotaoGerarRelatorio
                                aguardando={props.aguardando}
                                gerarPdf={() => {
                                    if (!props.filtro.unidades_consumidoras.length && !props.filtro.id_cliente) {
                                        return setError("Selecione um cliente ou alguma unidade consumidora para gerar o relatório");
                                    }
                                    const linhas = montarLinhas(faturasFiltradas);
                                    gerarRelatorioPdf({ statusAtivos, cabecalho, rodape, linhas });
                                }}
                                gerarXlsx={() => {
                                    //criar função que faz download múltiplo
                                    const dados = gerarDadosRelatorioXlsx();
                                    props.gerarXlsx({ nomeArquivo: "Faturas", dados });
                                }}
                            />,
                            <Button
                                title="Imprime várias faturas combinadas em um único arquivo PDF"
                                disabled={props.aguardando}
                                icon="fas fa-print"
                                text="Imprimir Múltiplas"
                                type={"primary"}
                                event={async () => {
                                    //criar função que faz download múltiplo
                                    props.imprimirMultiplasFaturas(faturasFiltradas);
                                }}
                            />,

                            <Button
                                title="Baixa várias faturas ao mesmo tempo, conforme seleção dos filtros da tela"
                                disabled={props.aguardando}
                                icon="fas fa-file-download"
                                text="Baixar Múltiplas"
                                type={"primary"}
                                event={async () => {
                                    //criar função que faz download múltiplo
                                    props.baixarMultiplasFaturasPdf(faturasFiltradas);
                                }}
                            />,

                            <Button
                                title="Baixa uma planilha do excel com os dados listados na tabela"
                                disabled={props.aguardando}
                                icon="fas fa-file-excel"
                                text="Gerar XLS Contábil"
                                type={"success"}
                                event={() => {
                                    const dados = gerarDadosXlsxContabil();
                                    props.gerarXlsx({ nomeArquivo: "Faturas", dados });
                                }}
                            />
                        ]}
                    />
                    {props.listaFaturasVencidas.length > 0 && (
                        <div className="d-flex align-items-center my-1 p-2" style={{ cursor: "pointer" }} onClick={() => setState({ ...state, exibirModalFaturasVencidas: true })}>
                            <div>
                                <AlertIcon animationClass={"alerta-triangulo-visualizado pr-2 pb-1"} title="" event={() => {}} />
                            </div>
                            <span
                                style={{
                                    color: "#e40f0f",
                                    fontWeight: "bold",
                                    fontSize: "clamp(15px, 2vw, 18px)",
                                }}
                            >
                                {" "}
                                Visualizar Faturas Vencidas de Meses Anteriores{" "}
                            </span>
                        </div>
                    )}

                    {isMobile && usuarioLogadoAcessoCliente ? (
                        faturasFiltradas.map((item) => buildCard(item))
                    ) : (
                        <Table responsive>
                            <THead>
                                <NewTr backgroundColorTr={"#FFFFFF"} backgroundColorTd={"#F5F5F5"}>
                                    <Th sticky style={{ fontSize: "0.7rem" }} alignCenter title="Status da Importação das Faturas de Energia Elétrica">
                                        Status Imp. Fatura
                                    </Th>
                                    <Th sticky style={{ fontSize: "0.7rem" }} minWidth={65} alignCenter title="Status da Importação de Produção de Energia Elétrica Solar">
                                        Status Imp. Prod. Solar
                                    </Th>
                                    <Th sticky style={{ fontSize: "0.7rem" }} minWidth={75} alignCenter title="Saldo de Produção Solar da Fatura de Energia Elétrica">
                                        Saldo Prod. Solar
                                    </Th>
                                    <Th sticky style={{ fontSize: "0.7rem" }} minWidth={75} alignCenter>
                                        Competência
                                    </Th>
                                    {!usuarioLogadoAcessoCliente && (
                                        <Th sticky style={{ fontSize: "0.7rem" }} alignCenter>
                                            Cliente
                                        </Th>
                                    )}
                                    {/* <Th sticky style={{ fontSize: "0.7rem" }} minWidth={100} alignCenter>
                                        Nº da Nota Fiscal
                                    </Th> */}
                                    <Th sticky style={{ fontSize: "0.7rem" }} alignCenter>
                                        UC
                                    </Th>
                                    <Th sticky style={{ fontSize: "0.7rem" }} minWidth={120} maxWidth={150} alignCenter>
                                        Característica de Conexão com Distribuidora de Energia
                                    </Th>
                                    <Th sticky style={{ fontSize: "0.7rem" }} minWidth={75} alignCenter>
                                        Data de Vencimento
                                    </Th>
                                    <Th sticky style={{ fontSize: "0.7rem" }} minWidth={75} alignCenter>
                                        Data de Pagamento
                                    </Th>
                                    {/* <Th sticky style={{ fontSize: "0.7rem" }} minWidth={120} alignCenter>
                                        <p style={{ marginBottom: 0 }}>Usuário de Alteração</p>
                                        <p style={{ marginBottom: 0 }}>Data de Pagamento</p>
                                    </Th> */}

                                    <Th sticky style={{ fontSize: "0.7rem" }} minWidth={120} alignCenter>
                                        Total Fatura
                                    </Th>
                                    <Th sticky style={{ fontSize: "0.7rem" }} alignCenter>
                                        Faturas
                                    </Th>
                                    <Th sticky style={{ fontSize: "0.7rem" }} alignCenter>
                                        Cód. Barras
                                    </Th>
                                    <Th sticky style={{ fontSize: "0.7rem" }} maxWidth={75} alignCenter>
                                        Download Realizado
                                    </Th>
                                </NewTr>
                            </THead>
                            {props.aguardando ? null : (
                                <TBody>
                                    {faturasFiltradas.map((item) => buildRow(item))}
                                    {rodape}
                                </TBody>
                            )}
                        </Table>
                    )}
                </ContentCardBody>
            </ContentCard>
        );
    }

    function gerarDadosXlsxContabil() {
        //criar função que faz download múltiplo
        const meses = ["JAN", "FEV", "MAR", "ABR", "MAI", "JUN", "JUL", "AGO", "SET", "OUT", "NOV", "DEZ"];
        const dados = [...faturasFiltradas].map((item) => {
            //FORMATA COMPETENCIA
            const ano = String(item.competencia).substring(0, 4);
            const indiceMes = parseInt(String(item.competencia).substring(4, 6)) - 1;
            const mesString = meses[indiceMes];
            return {
                "CNPJ Emissor": item.cnpj_emissor ? FormatUtils.formatarCNPJ(item.cnpj_emissor) : "Verificar cadastro",
                "CPF/CNPJ Pagador": item.cnpj_pagador
                    ? FormatUtils.formatarCNPJ(item.cnpj_pagador)
                    : item.cpf_pagador
                      ? FormatUtils.formatarCPF(item.cpf_pagador)
                      : "Verificar cadastro",
                "Nº Nota Fiscal": item.arquivo_pdf ? item.numero_nota_fiscal || "Verificar cadastro" : "Fatura não importada",
                "Data Emissão NF": item.arquivo_pdf ? DateFormat.formatarDataSqlParaTela(item.data_emissao_nota_fiscal) || "Verificar cadastro" : "Fatura não importada",
                "Mês de Referência": item.competencia ? `${mesString.toLocaleLowerCase()}/${ano}` : null,
                Vencimento: item.arquivo_pdf ? DateFormat.formatarDataSqlParaTela(item.data_vencimento) || "Verificar cadastro" : "Fatura não importada",
                "Valor a Pagar": item.arquivo_pdf ? adicionarPontosMilhar(parseFloat(item.valor_fatura) || 0) : "Fatura não importada",
                "Valor do ICMS": item.arquivo_pdf ? adicionarPontosMilhar(parseFloat(item.valor_icms) || 0) : "Fatura não importada",
                "Unidade Consumidora": item.numero_unidade_consumidora || item.numero,
            };
        });
        return dados;
    }

    function buildCard(item) {
        const deveRenderizarBotaoPdf = item.arquivo_pdf && (item.visualizacao_disponivel_cliente || props.usuarioLogado.administrador);

        const styles = {
            card: {
                background: "linear-gradient(145deg, #0A192F, #0D253F)",
                borderRadius: "18px",
                border: "1px solid rgba(255, 255, 255, 0.08)",
                boxShadow: "0 10px 30px rgba(0,0,0,0.6)",
                padding: "16px",
                color: "#FFFFFF",
                marginBottom: "15px",
            },

            highlightBox: {
                background: "rgba(26, 54, 93, 0.6)",
                backdropFilter: "blur(8px)",
                borderRadius: "12px",
                padding: "10px",
                border: "1px solid rgba(255,255,255,0.08)",
                height: "100%",
            },

            label: {
                fontSize: "0.7rem",
                color: "#A0AEC0",
                textTransform: "uppercase",
                fontWeight: "bold",
                letterSpacing: "0.5px",
                marginBottom: "4px",
                display: "block",
            },

            value: {
                fontSize: "1rem",
                fontWeight: "600",
                color: "#FFFFFF",
            },

            solarBox: {
                borderRadius: "8px",
                overflow: "hidden",
                border: "1px solid rgba(66,153,225,0.5)",
                textAlign: "left",
                background: "rgba(26,54,93,0.4)",
            },

            solarHeader: {
                background: "linear-gradient(90deg, #2C5282, #4299E1)",
                color: "white",
                fontSize: "0.6rem",
                textAlign: "center",
                padding: "2px 0",
                fontWeight: "bold",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "4px",
            },

            solarContent: {
                background: "linear-gradient(90deg, #2C5282 0%, #4299E1 100%)",
                padding: "5px 3px",
                fontSize: "0.85rem",
                lineHeight: "1.4",
                fontWeight: "bold",
                color: "#FFFFFF",
            },

            footer: {
                marginTop: "15px",
                padding: "10px 15px",
                background: "linear-gradient(90deg, #2C5282 0%, #4299E1 100%)",
                borderRadius: "12px",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                boxShadow: "0 4px 15px rgba(66,153,225,0.3)",
            },
        };

        const dataPagamento = item.nome_usuario_data_pagamento && !item.data_pagamento ? "Removida" : DateFormat.formatarDataSqlParaTela(item.data_pagamento);
        const naoImportada = !item.visualizacao_disponivel_cliente;

        return (
            <Grid cols="12">
                <div style={styles.card}>
                    {/* Unidade Consumidora */}
                    <div style={{ marginBottom: "12px" }}>
                        <div
                            style={{
                                ...styles.highlightBox,
                                display: "flex",
                                flexDirection: "column",
                                position: "relative",
                                paddingBottom: "30px",
                            }}
                        >
                            {/* Linha superior: ícone de raio + label */}
                            <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
                                <span className="fa-stack">
                                    <i className="far fa-circle fa-stack-2x" style={{ transform: "scale(0.90)" }}></i>
                                    <i className="fas fa-bolt fa-stack-1x" style={{ fontSize: "14px" }}></i>
                                </span>
                                <span style={styles.label}>Unidade Consumidora</span>
                            </div>

                            {/* Linha do meio: nome da unidade */}
                            <div
                                style={{
                                    ...styles.value,
                                    fontSize: "0.85rem",
                                    marginLeft: "29px",
                                    marginTop: "4px",
                                    marginBottom: "15px",
                                }}
                            >
                                {item.nome_unidade_consumidora}
                            </div>

                            {/* Linha inferior: ícones e concessionária */}
                            <div
                                style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    position: "absolute",
                                    bottom: "8px",
                                    left: "12px",
                                    right: "12px",
                                }}
                            >
                                {/* Ícones solar/remota */}
                                <div style={{ display: "flex", alignItems: "center", transform: "scale(0.75)", transformOrigin: "left bottom" }}>
                                    <SolCasaFatura fatura={item} />
                                </div>

                                {/* Concessionária */}
                                <div style={{ opacity: 0.6, fontSize: "0.75rem", textAlign: "right" }}>{item.nome_concessionaria}</div>
                            </div>
                        </div>
                    </div>

                    <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "10px" }}>
                        {/* Competência */}
                        <div style={styles.highlightBox}>
                            <span style={{ ...styles.label, textAlign: "center", marginTop: "10px" }}>Competência</span>
                            <i
                                className="fas fa-calendar-alt"
                                style={{
                                    fontSize: "20px",
                                    marginTop: "20px",
                                    textAlign: "center",
                                    display: "flex",
                                    justifyContent: "center",
                                }}
                            ></i>
                            <div style={{ ...styles.value, textAlign: "center", marginTop: "10px", fontSize: "20px" }}>{item.competencia_formatada}</div>
                        </div>

                        {/* Saldo e Balanço - apenas renderiza se mobile E existe unidade solar */}
                        {(!isMobile || item.unidade_geradora || item.unidade_remota) && (
                            <div style={styles.solarBox}>
                                {/* Botão Saldos */}
                                {item.saldo_geracao !== undefined && (
                                    <div>
                                        <Button
                                            style={{
                                                width: "100%",
                                                height: "32px",
                                                padding: 0,
                                                margin: 0,
                                                borderRadius: "0px",
                                                border: "none",
                                                background: "linear-gradient(to bottom right, #1b2736 0%, #48BB78 100%)",
                                            }}
                                            title="Visualizar gráfico de saldo de geração (kWh)"
                                            text={
                                                <div
                                                    style={{
                                                        width: "100%",
                                                        height: "100%",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "center",
                                                        fontSize: "0.7rem",
                                                        color: "#fff",
                                                    }}
                                                >
                                                    <i className="fas fa-chart-bar mr-2"></i>Saldos
                                                </div>
                                            }
                                            solid={true}
                                            type={"secondary"}
                                            disabled={!item.unidade_geradora && !item.unidade_remota}
                                            event={() => {
                                                props.getListaGraficoGeracaoSaldo({
                                                    id_cliente: item.id_cliente,
                                                    id_unidade_consumidora: item.id_unidade_consumidora,
                                                });
                                                setState({
                                                    ...state,
                                                    exibirGraficoSaldoGeracao: true,
                                                    itemSelecionado: {
                                                        id_cliente: item.id_cliente,
                                                        id_unidade_consumidora: item.id_unidade_consumidora,
                                                    },
                                                });
                                            }}
                                        />
                                    </div>
                                )}

                                {/* Conteúdo de saldos */}
                                {item.saldo_geracao !== undefined && (
                                    <div
                                        style={{
                                            ...styles.solarContent,
                                            // Se for mobile e não houver botão de Balanço Energético
                                            paddingBottom: isMobile && !item.unidade_geradora ? "40px" : "5px",
                                        }}
                                    >
                                        <TabelaSaldosFatura
                                            item={{
                                                id_grupo_faturamento: 1,
                                                saldo_geracao_p: item.saldo_p || 0,
                                                saldo_geracao_fora_ponta: item.saldo_fp || 0,
                                                saldo_geracao: item.saldo_geracao || 0,
                                                saldo_geracao_mes_anterior: item.saldo_geracao_mes_anterior || 0,
                                            }}
                                        />
                                    </div>
                                )}

                                {/* Botão Balanço Energético */}
                                {item.unidade_geradora && (
                                    <div>
                                        <Button
                                            style={{
                                                width: "100%",
                                                height: "40px",
                                                padding: 0,
                                                margin: 0,
                                                borderRadius: "0px",
                                                border: "none",
                                                background: "linear-gradient(to bottom right, #1b2736 0%, #48BB78 100%)",
                                            }}
                                            type="secondary"
                                            solid={true}
                                            title="Balanço Energético"
                                            text={
                                                <div>
                                                    <div style={{ fontSize: "0.7rem", marginBlock: 2 }}>
                                                        <i className="fas fa-balance-scale mr-2"></i>
                                                        <span className="mr-2">Balanço</span>
                                                    </div>
                                                    <div style={{ fontSize: "0.7rem" }}>
                                                        <i className="fas fa-bolt ml-2 mr-1"></i> Energético
                                                    </div>
                                                </div>
                                            }
                                            event={() =>
                                                setState({
                                                    ...state,
                                                    exibirModalBalancoEnergetico: true,
                                                    itemSelecionado: item,
                                                })
                                            }
                                        />
                                    </div>
                                )}
                            </div>
                        )}
                    </div>

                    {/* Datas */}
                    <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", marginTop: "15px", gap: "10px" }}>
                        <div>
                            <div style={styles.highlightBox}>
                                <span style={{ ...styles.label, textAlign: "center", marginTop: "10px" }}>Vencimento</span>
                                <i
                                    className="fas fa-calendar-alt"
                                    style={{ fontSize: "20px", marginTop: "20px", textAlign: "center", display: "flex", justifyContent: "center" }}
                                ></i>
                                <div style={{ fontSize: "20px", fontWeight: "bold", textAlign: "center", marginTop: "10px" }}>
                                    {DateFormat.formatarDataSqlParaTela(item.data_vencimento)}
                                </div>
                            </div>
                        </div>
                        <div style={{ textAlign: "right" }}>
                            <div style={styles.highlightBox}>
                                {/* Substitui o título dinamicamente */}
                                <span style={{ ...styles.label, textAlign: "center", marginTop: "10px" }}>{naoImportada ? "Fatura" : "Pagamento"}</span>
                                {(() => {
                                    const hoje = new Date();
                                    const vencimento = new Date(item.data_vencimento);
                                    const diffDias = Math.floor((vencimento - hoje) / (1000 * 60 * 60 * 24));

                                    if (naoImportada) {
                                        return (
                                            <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                                                {/* Ícone centralizado */}
                                                <div
                                                    style={{
                                                        width: "26px",
                                                        height: "26px",
                                                        borderRadius: "50%",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "center",
                                                        color: "#FFF",
                                                        fontSize: "20px",
                                                        margin: "5px 0",
                                                        boxShadow: "0 2px 4px rgba(0,0,0,0.3)",
                                                    }}
                                                >
                                                    <i className="fas fa-ban"></i>
                                                </div>

                                                {/* Mensagem abaixo do ícone */}
                                                <div
                                                    style={{
                                                        fontSize: "0.7rem",
                                                        fontWeight: "bold",
                                                        color: "#A0AEC0",
                                                        textAlign: "center",
                                                    }}
                                                >
                                                    Não Importado
                                                </div>
                                            </div>
                                        );
                                    }

                                    let statusPagamento = "pendente";

                                    if (item.fatura_isenta || (item.data_pagamento && dataPagamento !== "Removida")) {
                                        statusPagamento = "pago";
                                    } else if (diffDias >= 0 && diffDias <= 2) {
                                        statusPagamento = "proximo";
                                    } else if (diffDias < 0) {
                                        statusPagamento = "vencido";
                                    }

                                    return (
                                        <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                                            {/* Ícone */}
                                            {statusPagamento === "pago" && (
                                                <div
                                                    style={{
                                                        width: "26px",
                                                        height: "26px",
                                                        background: "#2fb260",
                                                        borderRadius: "50%",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "center",
                                                        color: "white",
                                                        fontSize: "12px",
                                                        margin: "5px 0",
                                                        boxShadow: "0 2px 4px rgba(0,0,0,0.3)",
                                                    }}
                                                >
                                                    <i className="fas fa-check"></i>
                                                </div>
                                            )}

                                            {statusPagamento === "proximo" && (
                                                <>
                                                    <div
                                                        style={{
                                                            width: "26px",
                                                            height: "26px",
                                                            background: "#facc15",
                                                            borderRadius: "50%",
                                                            display: "flex",
                                                            alignItems: "center",
                                                            justifyContent: "center",
                                                            color: "#000",
                                                            fontSize: "12px",
                                                            margin: "5px 0",
                                                            boxShadow: "0 2px 4px rgba(0,0,0,0.3)",
                                                        }}
                                                    >
                                                        <i className="fas fa-exclamation-triangle"></i>
                                                    </div>

                                                    <div
                                                        style={{
                                                            fontSize: "0.7rem",
                                                            fontWeight: "bold",
                                                            color: "#fbbf24",
                                                            textAlign: "center",
                                                            marginBottom: "3px",
                                                        }}
                                                    >
                                                        Um ou dois dias
                                                        <br />
                                                        para o vencimento
                                                    </div>
                                                </>
                                            )}

                                            {statusPagamento === "vencido" && (
                                                <>
                                                    <div
                                                        style={{
                                                            width: "26px",
                                                            height: "26px",
                                                            background: "#f87171",
                                                            borderRadius: "50%",
                                                            display: "flex",
                                                            alignItems: "center",
                                                            justifyContent: "center",
                                                            color: "white",
                                                            fontSize: "12px",
                                                            margin: "5px 0",
                                                            boxShadow: "0 2px 4px rgba(0,0,0,0.3)",
                                                        }}
                                                    >
                                                        <i className="fas fa-exclamation-triangle"></i>
                                                    </div>

                                                    <div
                                                        style={{
                                                            fontSize: "0.7rem",
                                                            fontWeight: "bold",
                                                            color: "#ef4444",
                                                            textAlign: "center",
                                                            marginBottom: "3px",
                                                        }}
                                                    >
                                                        Vencendo hoje
                                                        <br />
                                                        ou vencida
                                                    </div>
                                                </>
                                            )}

                                            {item.fatura_isenta || (item.data_pagamento && dataPagamento !== "Removida") ? (
                                                <div
                                                    style={{
                                                        fontSize: "0.8rem",
                                                        fontWeight: "bold",
                                                        color: "#4ade80",
                                                        textAlign: "center",
                                                    }}
                                                >
                                                    {item.fatura_isenta ? "Fatura Isenta" : dataPagamento}
                                                </div>
                                            ) : statusPagamento === "proximo" || statusPagamento === "vencido" ? null : (
                                                <div
                                                    style={{
                                                        fontSize: "1rem",
                                                        fontWeight: "bold",
                                                        color: "#83a9b8",
                                                        textAlign: "center",
                                                        marginTop: "10px",
                                                    }}
                                                >
                                                    -
                                                </div>
                                            )}
                                        </div>
                                    );
                                })()}
                            </div>
                        </div>
                    </div>

                    {/* Valor Total e Botão PDF */}
                    <div style={styles.footer}>
                        {isMobile && !item.visualizacao_disponivel_cliente ? (
                            // Mobile e não importada: mostra apenas a mensagem
                            <div style={{ textAlign: "center", color: "#ffff", fontWeight: "bold", fontSize: "1rem", width: "100%" }}>Fatura Indisponível</div>
                        ) : (
                            // Caso contrário, renderiza normalmente
                            <>
                                <div style={{ display: "flex", flexDirection: "column" }}>
                                    <span style={{ fontSize: "0.65rem", fontWeight: "bold", textTransform: "uppercase", opacity: 0.9 }}>Total da Fatura</span>
                                    <span style={{ fontSize: "1.3rem", fontWeight: "800" }}>{"R$ " + adicionarPontosMilhar(item.valor_fatura || 0)}</span>
                                </div>

                                {deveRenderizarBotaoPdf && (
                                    <ButtonTable
                                        style={{
                                            textAlign: "center",
                                            width: "35%",
                                            height: "35px",
                                            margin: 0,
                                            backgroundColor: "#fff",
                                            color: "#3182CE",
                                            borderRadius: "8px",
                                        }}
                                        type="primary"
                                        visible={true}
                                        event={() => {
                                            if (item.id_tipo_mercado == 2) {
                                                return setState({ ...state, exibirModalSelecaoFatura: true, itemPdfSelecionado: item });
                                            }
                                            props.buscarPdf(
                                                item.id,
                                                `Fatura_UC-${item.nome_unidade_consumidora.replace(/\./g, "").split("-")[0].trim()}_${String(item.competencia).substring(4, 6)}-${String(item.competencia).substring(0, 4)}`
                                            );
                                            props.setArquivoPDF();
                                        }}
                                    >
                                        <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "6px" }}>
                                            <i className="fas fa-file-pdf"></i>
                                            <span style={{ fontSize: "11px", fontWeight: "bold", lineHeight: "1" }}>Baixar Fatura</span>
                                        </div>
                                    </ButtonTable>
                                )}
                            </>
                        )}
                    </div>
                </div>
            </Grid>
        );
    }

    function buildRow(item) {
        const botoes = montarBotoes(item);

        let textColor = "#000";
        let backgroundColorTr = CORES[item.cor].backgroundColorTr;
        let backgroundColorTd = CORES[item.cor].backgroundColorTd;
        //se o download foi realizado diminui 50 de cada valor rgb, pra escurecer a linha
        if (validarDownloadRealizado(item)) {
            textColor = "#FFF";
            backgroundColorTr = `rgb(${backgroundColorTr.match(/\d+/g).map((v) => (parseInt(v) >= 90 ? parseInt(v) - 90 : 0))})`;
            backgroundColorTd = `rgb(${backgroundColorTd.match(/\d+/g).map((v) => (parseInt(v) >= 90 ? parseInt(v) - 90 : 0))})`;
        }

        const dataPagamento = <>{item.nome_usuario_data_pagamento && !item.data_pagamento ? "Removida" : DateFormat.formatarDataSqlParaTela(item.data_pagamento)}</>;
        const mensagensImportacao =
            !item.mensagem_ultima_importacao_data_pagamento || String(item.mensagem_ultima_importacao_data_pagamento).includes("OK") || item.fatura_isenta || item.data_pagamento
                ? null
                : `DATA DE PAGAMENTO - ${item.mensagem_ultima_importacao_data_pagamento}`;

        const temAlgumArquivo =
            item.arquivo_pdf ||
            item.arquivo_pdf_custo_energia_acl_cp ||
            item.arquivo_pdf_custo_energia_acl_lp ||
            item.arquivo_pdf_custo_gestao_acl ||
            item.arquivo_pdf_contribuicao_associativa_ccee;

        const deveRenderizarBotaoPdf = temAlgumArquivo && (!item.erros_importacao.length || item.importacao_validada || props.usuarioLogado.administrador);
        return (
            <NewTr
                style={{ color: textColor }}
                backgroundColorTr={backgroundColorTr}
                backgroundColorTd={backgroundColorTd}
                key={`${item.id_unidade_consumidora}-${item.id}`}
                botoes={botoes}
            >
                <Td backgroundColor={!item.visualizacao_disponivel_cliente ? null : backgroundColorTd} alignCenter minWidth={100}>
                    {!item.visualizacao_disponivel_cliente ? "Não Importado" : "Validado"}
                    <InfoIcon visible={props.usuarioLogado.administrador && mensagensImportacao} title={mensagensImportacao} />
                </Td>
                <Td minWidth={75} alignCenter backgroundColor={backgroundColorTr}>
                    <SolCasaFatura fatura={item} />
                </Td>
                <Td minWidth={115} alignCenter color={(!item.unidade_geradora && !item.unidade_remota) || parseFloat(item.saldo_geracao) ? null : "#800"}>
                    {item.unidade_geradora || item.unidade_remota ? (
                        <>
                            <div>
                                <Button
                                    style={{ margin: 0, padding: 3 }}
                                    title="Visualizar gráfico de saldo de geração (kWh)"
                                    text={
                                        <div style={{ fontSize: "0.7rem" }}>
                                            <i className="fas fa-chart-bar mr-2"></i>Saldos
                                        </div>
                                    }
                                    solid={true}
                                    type={"info"}
                                    disabled={!item.unidade_geradora && !item.unidade_remota}
                                    event={() => {
                                        props.getListaGraficoGeracaoSaldo({
                                            id_cliente: item.id_cliente,
                                            id_unidade_consumidora: item.id_unidade_consumidora,
                                        });
                                        setState({
                                            ...state,
                                            exibirGraficoSaldoGeracao: true,
                                            itemSelecionado: {
                                                id_cliente: item.id_cliente,
                                                id_unidade_consumidora: item.id_unidade_consumidora,
                                            },
                                        });
                                    }}
                                />
                            </div>
                            <TabelaSaldosFatura item={item} />
                            {item.unidade_geradora && (
                                <div>
                                    <Button
                                        style={{ margin: "2px 0px", padding: 0, height: 30, width: 130, lineHeight: "0.6rem" }}
                                        type="success"
                                        solid={true}
                                        title="Balanço Energético"
                                        text={
                                            <div>
                                                <div style={{ fontSize: "0.7rem", marginBlock: 2 }}>
                                                    <i className="fas fa-balance-scale mr-2"></i>
                                                    <span className="mr-2">Balanço</span>
                                                </div>
                                                <div style={{ fontSize: "0.7rem" }}>
                                                    <i className="fas fa-bolt ml-2 mr-1"></i> Energético
                                                </div>
                                            </div>
                                        }
                                        event={() => setState({ ...state, exibirModalBalancoEnergetico: true, itemSelecionado: item })}
                                    />
                                </div>
                            )}
                        </>
                    ) : (
                        " - "
                    )}
                </Td>
                <Td minWidth={50} alignCenter>
                    {item.competencia_formatada}
                </Td>
                {!usuarioLogadoAcessoCliente && <Td minWidth={80}>{item.nome_cliente}</Td>}
                <Td minWidth={120}>{item.nome_unidade_consumidora + " (" + item.nome_concessionaria + ")"}</Td>
                <Td fontSize="0.85rem" alignCenter>
                    <TableInCell
                        lista={[
                            { cabecalho: "Tipo Medição", valor: item.sigla_tipo_medicao || " - " },
                            { cabecalho: "Tipo de Transformador", valor: item.nome_tipo_transformador || " - " },
                            {
                                cabecalho: "Grupo de Faturamento",
                                valor: (
                                    <span title={item.sigla_grupo_faturamento}>
                                        {item.sigla_grupo_faturamento && item.sigla_grupo_faturamento.indexOf("(") >= 0
                                            ? item.sigla_grupo_faturamento.substring(0, item.sigla_grupo_faturamento.indexOf("("))
                                            : item.sigla_grupo_faturamento || " - "}
                                    </span>
                                ),
                                width: 120,
                            },
                        ]}
                    />
                </Td>
                <Td minWidth={50} alignCenter>
                    {DateFormat.formatarDataSqlParaTela(item.data_vencimento)}
                </Td>
                <Td minWidth={120} alignCenter>
                    {item.fatura_isenta ? (
                        <span style={{ fontSize: "13px", display: "inline-flex", borderRadius: "0.3rem", backgroundColor: "#00adff", color: "#FFF", padding: 5 }}>
                            Fatura Isenta
                        </span>
                    ) : (
                        <div>{dataPagamento}</div>
                    )}

                    {item.fatura_isenta ? (
                        <div
                            style={{ marginTop: 12 }}
                            title={item.datahora_alteracao_data_pagamento ? DateFormat.formatarDataHoraSqlParaTela(item.datahora_alteracao_data_pagamento) : "Sem data disponível"}
                        >
                            Definida pelo sistema
                        </div>
                    ) : (
                        <div style={{ marginTop: 12 }}>
                            <p
                                style={{ margin: 0 }}
                                title={
                                    item.nome_usuario_data_pagamento || item.datahora_alteracao_data_pagamento
                                        ? "Verificado " +
                                          (item.datahora_alteracao_data_pagamento
                                              ? DateFormat.formatarDataHoraSqlParaTela(item.datahora_alteracao_data_pagamento)
                                              : "Sem data disponível")
                                        : ""
                                }
                            >
                                {item.data_pagamento ? item.nome_usuario_data_pagamento || "Definida pelo sistema" : item.nome_usuario_data_pagamento}
                            </p>
                        </div>
                    )}
                </Td>

                <Td minWidth={50} alignCenter>
                    {"R$ " + adicionarPontosMilhar(item.valor_fatura || 0)}
                </Td>
                <Td alignCenter minWidth={150}>
                    {deveRenderizarBotaoPdf ? (
                        <ButtonTable
                            style={{ width: "95%", height: "35px", margin: "5px 2px 4px " }}
                            title="Visualizar PDF"
                            type={"primary"}
                            icon={"fas fa-file-pdf"}
                            visible={true}
                            event={() => {
                                if (item.id_tipo_mercado == 2) {
                                    return setState({
                                        ...state,
                                        exibirModalSelecaoFatura: true,
                                        itemPdfSelecionado: item,
                                    });
                                }
                                props.buscarPdf(
                                    item.id,
                                    `Fatura_UC-${item.nome_unidade_consumidora.replace(/\./g, "").split("-")[0].trim()}_${String(item.competencia).substring(4, 6)}-${String(
                                        item.competencia
                                    ).substring(0, 4)}`
                                );
                                props.setArquivoPDF();
                            }}
                        >
                            <div style={{ display: "flex", alignItems: "center", gap: "6px", justifyContent: "center" }}>
                                <i className="fas fa-file-pdf"></i>
                                <span style={{ marginTop: "2px", fontSize: "14px", fontWeight: "bold" }}>Baixar Fatura</span>
                            </div>
                        </ButtonTable>
                    ) : null}

                    <div>
                        {item.data_emissao_nota_fiscal ? (
                            <p
                                style={{
                                    textAlign: "center",
                                    fontSize: "0.6rem",
                                    margin: "0 0 0 0",
                                }}
                            >
                                Emitida em: {DateFormat.formatarDataSqlParaTela(item.data_emissao_nota_fiscal)}{" "}
                            </p>
                        ) : null}
                    </div>
                    {item.numero_nota_fiscal != null ? (
                        <div
                            style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                color: "#000",
                                textAlign: "left",
                            }}
                        >
                            <div
                                title="Número de série da nota fiscal"
                                style={{
                                    fontSize: "0.6rem",
                                    width: 98,
                                    background: "#fff",
                                    padding: "1px",
                                    borderRadius: "5px",
                                    border: "1px solid #a8a5a5",
                                    cursor: "pointer",
                                }}
                            >
                                {`${item.numero_nota_fiscal}${item.serie_nota_fiscal ? " - " + item.serie_nota_fiscal : ""}`}
                            </div>

                            <button
                                title="Copiar n° de série"
                                onClick={() => copiarTextoClipboard(`${item.numero_nota_fiscal}${item.serie_nota_fiscal ? " - " + item.serie_nota_fiscal : ""}`)}
                                style={{
                                    marginLeft: -22,
                                    backgroundColor: "#fff",
                                    color: "#555",
                                    height: 17,
                                    width: 21,
                                    border: "1px solid #999",
                                    borderRadius: 4,
                                    outline: "none",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    padding: 0,
                                    cursor: "pointer",
                                }}
                            >
                                <i
                                    className="far fa-clone"
                                    style={{
                                        fontSize: "12px",
                                    }}
                                ></i>
                            </button>
                        </div>
                    ) : null}
                </Td>
                <Td alignCenter minWidth={50}>
                    {item.arquivo_pdf && (item.visualizacao_disponivel_cliente || props.usuarioLogado.administrador) ? (
                        <ButtonTable
                            style={{ margin: 0 }}
                            title="Copiar Código de Barras"
                            type={"primary"}
                            icon={"fas fa-barcode"}
                            visible={true}
                            event={() => {
                                props.extrairDadosPDF(item.id);
                            }}
                        />
                    ) : null}
                </Td>
                <Td alignCenter minWidth={50}>
                    {item.arquivo_pdf && validarDownloadRealizado(item) && (item.visualizacao_disponivel_cliente || props.usuarioLogado.administrador) ? (
                        <ButtonTable
                            style={{
                                margin: 0,
                                backgroundColor: "#28A745",
                                color: "#FFFFFF",
                                border: "1px solid #FFF",
                            }}
                            title='Alterar para "Download Pendente"'
                            icon={"fas fa-check-square"}
                            iconHover={"fas fa-times"}
                            backgroundColorHover="#fc2828"
                            colorHover="white"
                            visible={true}
                            event={() => props.excluirDownloadRealizado(item.id)}
                        />
                    ) : null}
                </Td>
            </NewTr>
        );
    }

    function montarLinhas(faturas) {
        const linhas = [];

        for (const item of faturas) {
            const { numero_nota_fiscal, serie_nota_fiscal, nome_unidade_consumidora, nome_concessionaria, nome_cliente } = item;
            const componente = buildRow(item);
            const totalCelulas = componente.props.children.length;
            let linhaModificada = Array.from(componente.props.children)
                .filter((child) => !!child)
                .splice(0, totalCelulas - 3);
            linhaModificada = React.Children.map(linhaModificada, (child, index) => {
                // Extrai propriedades personalizadas da linha original
                const backgroundColorTd = componente.props.backgroundColorTd || "";
                const backgroundColorTr = componente.props.backgroundColorTr || "";

                // 0 = status
                if (index === 0) {
                    const primeiroFilho = Array.isArray(child.props.children) && child.props.children.length > 0 ? child.props.children[0] : child.props.children;

                    return React.cloneElement(child, {
                        children: primeiroFilho,
                    });
                }

                // 4 = cliente
                if (!usuarioLogadoAcessoCliente && index === 4) {
                    return React.cloneElement(child, {
                        backgroundColor: index % 2 === 0 ? backgroundColorTd : backgroundColorTr,
                        children: (
                            <div
                                style={{
                                    textAlign: "center",
                                }}
                            >
                                {nome_cliente.length > 40 ? nome_cliente.substring(0, 40) + "..." : nome_cliente}
                            </div>
                        ),
                    });
                }
                // 5 = numero nota serie_nota_fiscal
                if (usuarioLogadoAcessoCliente ? index === 4 : index === 5) {
                    return React.cloneElement(child, {
                        backgroundColor: index % 2 === 0 ? backgroundColorTd : backgroundColorTr,
                        children: (
                            <div
                                style={{
                                    textAlign: "center",
                                }}
                            >
                                {numero_nota_fiscal != null && serie_nota_fiscal != null ? numero_nota_fiscal + "-" + serie_nota_fiscal : " - "}
                            </div>
                        ),
                    });
                }
                // 6 = UC
                if (usuarioLogadoAcessoCliente ? index === 5 : index === 6) {
                    return React.cloneElement(child, {
                        backgroundColor: index % 2 === 0 ? backgroundColorTd : backgroundColorTr,
                        children: (
                            <div
                                style={{
                                    textAlign: "center",
                                }}
                            >
                                {nome_unidade_consumidora.length > 45
                                    ? `${nome_unidade_consumidora.substring(0, 45)}... (${nome_concessionaria})`
                                    : `${nome_unidade_consumidora} (${nome_concessionaria})`}
                            </div>
                        ),
                    });
                }
                // Retorna o elemento sem alterações, mas aplica os estilos personalizados
                return React.cloneElement(child, {
                    backgroundColor: index % 2 === 0 ? backgroundColorTd : backgroundColorTr,
                });
            });
            const linhaSemColunaBotoes = React.cloneElement(componente, {
                children: linhaModificada,
                botoes: [],
            });

            linhas.push(linhaSemColunaBotoes);
        }
        return linhas;
    }

    function gerarRelatorioPdf({ statusAtivos, cabecalho, rodape, linhas }) {
        // props.setAguardando(true);
        const ucsSelecionadas = props.listaUnidadeConsumidora.filter((item) => props.filtro.unidades_consumidoras.find((uc) => uc.value == item.id));
        const nomesUcsSelecionadas = String(ucsSelecionadas.map((item) => item.valor));
        const totalCelulas = cabecalho.props.children.length;
        const linhaModificada = Array.from(cabecalho.props.children)
            .filter((child) => !!child)
            .splice(0, totalCelulas - 3);

        const cabecalhoSemColunasBotoes = (
            <NewTr>
                {linhaModificada.map((el, i) => {
                    const copia = React.cloneElement(
                        el,
                        {
                            key: i,
                            sticky: false,
                            style: { fontSize: "0.85rem", paddingTop: 30 },
                        },
                        [...el.props.children]
                    );
                    return copia;
                })}
            </NewTr>
        );
        const filtro = (
            <b style={{ fontSize: "0.8rem" }}>
                Cliente:
                {` ${(props.listaCliente.find((cliente) => cliente.id == props.filtro.id_cliente) || {}).valor || "Todos"} - `}
                UCs:
                {` ${nomesUcsSelecionadas.length ? nomesUcsSelecionadas : "Todas"} - `}
                Ano:{" " + (props.filtro.ano || "") + " - "}
                Mês:
                {` ${(props.listaMeses.find((mes) => mes.id == props.filtro.mes) || {}).valor || "Todos"} - `}
                Filtro por Status: {String(statusAtivos).replace(/\,/g, ", ")}
            </b>
        );
        const html = ReactDOMServer.renderToString(
            <TabelaFaturaClientePDF
                dadosImpressao={{
                    rodape,
                    linhas,
                    filtro,
                    cabecalhoSemColunasBotoes,
                }}
            />
        );
        props.gerarRelatorio({ html, landscape: true });
        // props.setArquivoPDF(pdfBase64, "Relatório faturas.pdf", "landscape");
    }

    function handleVerificarFaturas() {
        const listaFaturasMapeadas = [];
        for (const fatura of props.listaFaturasVencidas) {
            if (!listaFaturasMapeadas.find((fat) => fat.id_unidade_consumidora == fatura.id_unidade_consumidora)) {
                const todasFaturasDaUC = fatura.faturas_vencidas.map((fv) => ({
                    id_unidade_consumidora: fatura.id_unidade_consumidora,
                    nome_unidade_consumidora: fatura.nome_unidade_consumidora,
                    id: fv.id,
                }));
                listaFaturasMapeadas.push(...todasFaturasDaUC);
            }
        }
        props.setListaFaturasRedirecionamento(listaFaturasMapeadas);
        props.getListaFaturasCliente();
        setState({ ...state, exibirModalFaturasVencidas: false });
    }
}

const mapStateToProps = (state) => {
    return {
        usuarioLogado: state.auth.usuarioLogado,
        modoTela: state.fatura.modoTela,
        aguardando: state.fatura.aguardando,
        filtro: state.fatura.filtro,
        lista: state.fatura.lista,
        listaGraficoGeracaoSaldo: state.fatura.listaGraficoGeracaoSaldo,
        listaFaturasVencidas: state.fatura.listaFaturasVencidas,
        listaCliente: state.fatura.listaCliente,
        listaConcessionaria: state.fatura.listaConcessionaria,
        listaUnidadeConsumidora: state.fatura.listaUnidadeConsumidora,
        listaGrupoFaturamento: state.cliente.listaGrupoFaturamento,
        listaEmpenho: state.empenho.lista,
        listaMeses: state.fatura.listaMeses,
        totalFaturaEmpenho: state.fatura.totalFaturaEmpenho,
        pdf: state.displayPDF.pdf,
        id_pdf: state.displayPDF.id_pdf,
        nomePdf: state.displayPDF.nomePdf,
    };
};

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            setModoTela,
            initForm,
            setFiltro,
            getListaFaturasCliente,
            getListaEmpenho,
            buscarPdf,
            setArquivoPDF,
            incluirDownloadRealizado,
            excluirDownloadRealizado,
            setAguardando,
            setDataPagamento,
            getListaGrupoFaturamento,
            baixarMultiplasFaturasPdf,
            imprimirMultiplasFaturas,
            getTotalFaturaEmpenho,
            buscarPdfFaturaAdicional,
            extrairDadosPDF,
            gerarRelatorio,
            gerarXlsx,
            getFaturasVencidasUltimos4Meses,
            getListaGraficoGeracaoSaldo,
            setListaFaturasRedirecionamento,
            getListaClientesUcsFiltradosSelect,
        },
        dispatch
    );
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(FaturaEnergiaCliente));
